import {Box, SvgIcon, Typography} from "@mui/material";
import "./style.scss";
import {ReactComponent as IconID} from '../lib/icons/LoanIcon_ID.svg';
import {ReactComponent as IconAddress} from '../lib/icons/LoanIcon_address.svg';
import {ReactComponent as Icon18} from '../lib/icons/LoanIcon_18.svg';
import {ReactComponent as IconIncome} from '../lib/icons/LoanIcon_income.svg';

function Requirements({}) {
    return <>
        <Box className="calc-req-wrapper">
            <Box className="calc-req-need">
                <Typography variant="h6">What You’ll need</Typography>
                <Box className="calc-req-grid">
                    <Box className="calc-req-item">
                        <Box className="calc-req-item-icon">
                            <SvgIcon component={IconAddress} viewBox="0 0 500 500"/>
                        </Box>
                        <Typography component="p">Proof of Address</Typography>
                    </Box>
                    <Box className="calc-req-item">
                        <Box className="calc-req-item-icon">
                            <SvgIcon component={Icon18} viewBox="0 0 500 500"/>
                        </Box>
                        <Typography component="p">Must be over 18</Typography>
                    </Box>
                    <Box className="calc-req-item">
                        <Box className="calc-req-item-icon">
                            <SvgIcon component={IconID} viewBox="0 0 500 500"/>
                        </Box>
                        <Typography component="p">ID Required</Typography>
                    </Box>
                    <Box className="calc-req-item">
                        <Box className="calc-req-item-icon">
                            <SvgIcon component={IconIncome} viewBox="0 0 500 500"/>
                        </Box>
                        <Typography component="p">Proof of Income</Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    </>;
}

export default Requirements;
